import React, { Key } from 'react';
import { Form, FormInstance } from 'antd';
import { find } from 'lodash';

import { EPSelect, EPSelectOption } from '@/components';
import { getAssociableStationsByRowIndex } from '../UserCreateOrEditForm.utils';
import AssociableEntitiesStore from '@/store/AssociableEntitiesStore';

interface StationSelectCellProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  index: number;
  form: FormInstance;
  associableEntitiesStore: AssociableEntitiesStore;
  isDisabled: boolean;
  t: (key: string) => string;
  setTime: (date: Date) => void;
  stationLookupMap: Record<string, string>;
  getStationName: (stationId: string) => string;
}

const StationSelectCell: React.FC<StationSelectCellProps> = ({
  field,
  index,
  form,
  associableEntitiesStore,
  isDisabled,
  t,
  setTime,
  stationLookupMap,
  getStationName,
}) => {
  const currentValue = form.getFieldValue(['stationAndSubscriptions', field.name, 'stationId']);

  const associableStations = getAssociableStationsByRowIndex(index, form, associableEntitiesStore) || [];

  const currentStationInOptions = find(associableStations, { id: currentValue });

  return (
    <Form.Item
      {...field}
      name={[field.name, 'stationId']}
      key={[field.fieldKey, 'stationId'] as unknown as Key}
      rules={[{ required: true, message: t('Please choose a station') }]}
    >
      <EPSelect
        placeholder={t('Select station')}
        dropdownMatchSelectWidth={false}
        style={{ minWidth: 150 }}
        loading={associableEntitiesStore.isLoading}
        disabled={isDisabled}
        onChange={() => setTime(new Date())}
      >
        {currentValue && !currentStationInOptions && stationLookupMap[currentValue] && (
          <EPSelectOption key={currentValue} value={currentValue}>
            {getStationName(currentValue)}
          </EPSelectOption>
        )}

        {associableStations.map(station => (
          <EPSelectOption key={station.id} value={station.id}>
            {getStationName(station.id)}
          </EPSelectOption>
        ))}
      </EPSelect>
    </Form.Item>
  );
};

export default StationSelectCell;
